import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=7b6955b7&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=7b6955b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6955b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6955b7')) {
      api.createRecord('7b6955b7', component.options)
    } else {
      api.reload('7b6955b7', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=7b6955b7&scoped=true&", function () {
      api.rerender('7b6955b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/conversationBulkActions/Index.vue"
export default component.exports